// extracted by mini-css-extract-plugin
module.exports = {"arrow":"term-styles-module--arrow--1O1RY","pt":"term-styles-module--pt--2A7w3"};